import { useAppStatus } from "@/context";
import Link from "next/link";
import React from "react";
import { FaGithub } from "react-icons/fa";

const links: { name: string; href: string }[] = [
  {
    name: "Home",
    href: "https://brimble.io",
  },
  {
    name: "Docs",
    href: "https://docs.brimble.io",
  },
  {
    name: "Community",
    href: "https://linktr.ee/brimblehq",
  },
  {
    name: "Pricing",
    href: "https://brimble.io/pricing",
  },
];

const Footer = () => {
  const { appStatus } = useAppStatus();
  return (
    <footer className="container mx-auto w-full max-w-7xl px-4 pb-12">
      <div className="flex w-full flex-col items-center justify-between space-y-4 border-t border-gray-light py-5 dark:border-opacity-20 md:flex-row md:space-y-0">
        <ul className="flex items-center space-x-4">
          {links.map((link) => (
            <li
              key={link.name}
              className="text-sm font-medium text-gray-dark dark:text-theme-color-lighter"
            >
              <Link href={link.href}>
                <a target={"_blank"}>{link.name}</a>
              </Link>
            </li>
          ))}
        </ul>
        <ul className="flex items-center space-x-6 py-2">
          <Link href="https://status.brimble.io/">
            <a target="_blank">
              <div className="flex h-10 w-auto items-center justify-center rounded-none border border-status px-2 py-2 dark:border-opacity-30">
                <div
                  className={`h-3 w-3 rounded-full ${
                    appStatus === "UP" ? "bg-success" : "bg-danger"
                  }`}
                ></div>
                <p className="p-2 text-sm font-normal">
                  {`${
                    appStatus === "UP"
                      ? "Status : All systems work Perfectly"
                      : "Application Maintenance In Progress"
                  }`}
                </p>
              </div>
            </a>
          </Link>
          <li className="rounded-full bg-primary/10 p-2 text-primary">
            <Link href={"https://github.com/brimblehq"}>
              <a target={"_blank"}>
                <FaGithub />
              </a>
            </Link>
          </li>
          <li className="rounded-full bg-primary/10 p-2 text-primary">
            <Link href={"https://x.com/brimblehq"}>
              <a target={"_blank"}>
                <svg fill="currentColor" height="14" viewBox="0 0 22 20">
                  <path d="M16.99 0H20.298L13.071 8.26L21.573 19.5H14.916L9.702 12.683L3.736 19.5H0.426L8.156 10.665L0 0H6.826L11.539 6.231L16.99 0ZM15.829 17.52H17.662L5.83 1.876H3.863L15.829 17.52Z"></path>
                </svg>
              </a>
            </Link>
          </li>
        </ul>
      </div>
    </footer>
  );
};

export default Footer;
